import { render } from "./SchnellZugriff.vue?vue&type=template&id=301a6be4"
import script from "./SchnellZugriff.vue?vue&type=script&lang=js"
export * from "./SchnellZugriff.vue?vue&type=script&lang=js"

import "./SchnellZugriff.vue?vue&type=style&index=0&id=301a6be4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__